import { camelToSnake } from "./caseConvert";
// create formData from object with snake case
export const createRequestBody = (data) => {
    const formData = new FormData();
    Object.keys(data).map((key) => {
        formData.append(camelToSnake(key), data[key]);
    });
    return formData;
};
